// extracted by mini-css-extract-plugin
export var attachment = "_rx-a";
export var emailContainer = "_rx-4";
export var emailContentPaddedContainer = "_rx-b";
export var emailHeader = "_rx-6";
export var emailIframe = "_rx-3";
export var emailInfoIcon = "_rx-9";
export var emailShortenedSummary = "_rx-e";
export var infoDropdown = "_rx-0";
export var infoRowBoundedContent = "_rx-d";
export var internal = "_rx-5";
export var merchant = "_rx-8";
export var messageInputContainer = "_rx-h";
export var normal = "_rx-7";
export var replyCard = "_rx-f";
export var subtleButton = "_rx-1";
export var subtleButtonIconContainer = "_rx-2";
export var toggleViewRepliesButton = "_rx-c";
export var wrappingText = "_rx-g";